import { Component, OnInit, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LegendsComponentComponent } from "../legends-component/legends-component.component";

@Component({
  selector: "app-application-timeline",
  templateUrl: "./application-timeline.component.html",
  styleUrls: ["./application-timeline.component.scss"],
})
export class ApplicationTimelineComponent implements OnInit {
  userData: any;
  userType: any;

  @Input() timeline: any;
  expandedState: { [key: string]: boolean } = {
    Applicant: false,
    HSO: false,
    BCPO: false,
    'PESO-A': false,
    CMO: false,
    'PESO-B': false,
  };
  groupedTimelineData: any = {};

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
    const pesoArray = this.timeline.PESO || [];
    const pesoAElement = pesoArray.find(x => x.officeId !== 5);
    const pesoBElement = pesoArray.find(x => x.officeId === 5);
    this.groupedTimelineData = {
      ...this.timeline,
      'PESO-A': pesoAElement ? [pesoAElement] : [],
      'PESO-B': pesoBElement ? [pesoBElement] : []
    };

    this.userData = JSON.parse(localStorage.getItem("applicantDetails"))
      ? JSON.parse(localStorage.getItem("applicantDetails"))
      : JSON.parse(localStorage.getItem("evaluator_details"));

    this.userType = this.userData.officeName ? "evaluator" : "applicant";
  }

  toggleCardExpansion(key: string): void {
    this.expandedState[key] = !this.expandedState[key];
  }

  showLegends() {
    this.dialog.open(LegendsComponentComponent, {
      disableClose: true
    })
  }

}
